import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ApplicationDataService } from 'src/app/services/application-data.service';
import { NotificationService } from 'src/app/services/notification-service';
import { ReportService } from 'src/app/services/report.service';
import { ManageSuspensionPopupComponent } from '../manage-suspension-popup/manage-suspension-popup.component';
import { MatPaginator } from '@angular/material/paginator';
import { FormBuilder, FormGroup } from '@angular/forms';
import Swal from 'sweetalert2';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DebitOrderNotificationService } from 'src/app/services/debit-order-notification.service';
import { BatchProcessModuleType } from 'src/app/enum/batch-processType';

@Component({
  selector: 'app-manage-payment-arrangement',
  templateUrl: './manage-payment-arrangement.component.html',
  styleUrls: ['./manage-payment-arrangement.component.scss']
})
export class ManagePaymentArrangementComponent implements OnInit {

  data: any = [];
  dataSource = new MatTableDataSource(this.data);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator
  form: FormGroup
  displayedColumns: string[] = [
    "TypeOfProcess",
    "Date",
    "Status",
    "Count",
    "ProcessedDate",

  ];
  StatusTypeOfProcess = {
    1: 'New',
    2: 'InProgress',
    3: 'Success',
    4: 'Failed',
    5: 'Partial Success'
  };

  TypeOfProcess = {
    1: 'Payment Arrangement',
    2: 'Remainder Mail',
    3: 'Suspension Process',
    4: 'UnSuspend Process',
  };
  fileName: string;
  isFileSelected: boolean;
  file: any;
  BatchProcessModuleType: BatchProcessModuleType;
  show: boolean;
  constructor(
    private applicationDataService: ApplicationDataService,
    private reportService: ReportService,
    private toastr: NotificationService,
    private matdialog: MatDialog,
    private formBuilder: FormBuilder,
    private DebitOrderNotificationService: DebitOrderNotificationService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      AttachmentFileName: [],
      downloadtype: [null],
    })
    this.gettabledata();
  }
  gettabledata() {
    this.applicationDataService.getSuspensionGridData().subscribe((result) => {
      this.data = result.map((item: any) => ({
        ...item,
        date: item.date ? item.date.split('T')[0] : null,
        processStatusType: this.StatusTypeOfProcess[item.processStatusType]

      }))


      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.paginator = this.paginator
    })

  }
  clearFilter() {
    this.gettabledata();
    this.form.reset()
    this.show = false
  }
  getStatusClass(status: string): string {
    switch (status) {
      case 'New':
        return 'bg-new';
      case 'InProgress':
        return 'bg-inprogress';
      case 'Success':
        return 'bg-Success';
      case 'Failed':
      case 'Partial Success':
        return 'bg-failed';
      default:
        return '';
    }
  }

  download(data) {

    this.reportService.downloadCorrespondingData(data.id).subscribe((result) => {
      if (result != null) {
        this.form.get('downloadtype').setValue(String(data.processType));
        console.log("Value set:", this.form.get('downloadtype').value);
        this.Processtye('w')
        const linkSource = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64, ' + result;
        const downloadLink = document.createElement('a');
        const fileName = 'Processed Data.xlsx';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();

      }
      else {
        this.toastr.showError("No Data Available")
      }
      // this.clearFilter();
    });
  }
  // upload(data) {
  //   let head;
  //   let title;
  //   if (data.processType == 'Remainder Mail') {
  //     head = 'Bulk Send Of Remainder Mail';
  //     title = 'mail'
  //   }
  //   else if (data.processType == 'Suspension Process') {
  //     head = 'Bulk Customer Suspension';
  //     title = 'suspension'
  //   }
  //   else {
  //     head = 'Bulk Revoke';
  //     title = 'Revoke'

  //   }

  //   const dialogref = this.matdialog.open(ManageSuspensionPopupComponent, {
  //     autoFocus: false,
  //     disableClose: true,
  //     panelClass: 'mat-dialog',
  //     width: "40%",
  //     data: {
  //       head: head,
  //       title: title,
  //       data: data,
  //     }
  //   });
  //   dialogref.afterClosed().subscribe((result)=>{
  //     if(result)
  //     this.gettabledata();
  //   })
  // }
  // mail() {
  //   let head = 'Bulk Send Of Remainder Mail';
  //   let title = 'mail'
  //   const dialogref = this.matdialog.open(ManageSuspensionPopupComponent, {
  //     autoFocus: false,
  //     disableClose: true,
  //     panelClass: 'mat-dialog',
  //     width: "50%",
  //     data: {
  //       head: head,
  //       title: title,
  //       data: "0",

  //     }
  //   });
  //   dialogref.afterClosed().subscribe((result)=>{
  //     if(result)
  //     this.gettabledata();
  //   })

  // }
  // suspension() {
  //   let head = 'Bulk Customer Suspension';
  //   let title = 'suspension'
  //   const dialogref = this.matdialog.open(ManageSuspensionPopupComponent, {
  //     autoFocus: false,
  //     disableClose: true,
  //     panelClass: 'mat-dialog',
  //     width: "50%",
  //     data: {
  //       head: head,
  //       title: title,
  //       data: "0",

  //     }
  //   });
  //   dialogref.afterClosed().subscribe((result)=>{
  //     if(result)
  //     this.gettabledata();
  //   })

  // }

  // revoke() {
  //   let head = 'Bulk Revoke';
  //   let title = 'Revoke'
  //   const dialogref = this.matdialog.open(ManageSuspensionPopupComponent, {
  //     autoFocus: false,
  //     disableClose: true,
  //     panelClass: 'mat-dialog',
  //     width: "50%",
  //     data: {
  //       head: head,
  //       title: title,
  //       data: "0",

  //     }
  //   });
  //   dialogref.afterClosed().subscribe((result)=>{
  //     if(result)
  //     this.gettabledata();
  //   })

  // }
  // payment(){
  //   let head = 'Update Payment Arrangement';
  //   let title = 'payment'
  //   const dialogref = this.matdialog.open(ManageSuspensionPopupComponent, {
  //     autoFocus: false,
  //     disableClose: true,
  //     panelClass: 'mat-dialog',
  //     width: "50%",
  //     data: {
  //       head: head,
  //       title: title,
  //       data: "0",

  //     }
  //   });
  //   dialogref.afterClosed().subscribe((result)=>{
  //     if(result)
  //     this.gettabledata();
  //   })
  // }


  selectFile() {
    const inputElement = document.createElement('input');
    inputElement.type = 'file';
    inputElement.style.display = 'none';
    document.body.appendChild(inputElement);
    inputElement.click();

    inputElement.addEventListener('change', async (event: any) => {
      const files: FileList = (event.target as HTMLInputElement).files;

      if (!files || files.length === 0) {
        Swal.fire('Warning', 'Please upload a file', 'warning');
        return;
      }
      if (files.length > 1) {
        Swal.fire('Warning', 'Please upload only one file at a time', 'warning');
        return;
      }
      this.file = files[0];
      this.fileName = this.file.name;
      const fileExtension = this.fileName.split('.').pop().toLowerCase();
      const validExtensions = ['csv', 'xlsx', 'xls'];
      const validMimeTypes = ['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];

      const isValidExtension = validExtensions.includes(fileExtension);
      const isValidMimeType = validMimeTypes.includes(this.file.type);

      if (!isValidExtension || !isValidMimeType) {
        Swal.fire(
          'Warning',
          `Please upload a correct file format (csv, xlsx, xls)`,
          'warning'
        );
        this.fileName = '';
        this.isFileSelected = false;
        document.body.removeChild(inputElement);
        return;
      }
      this.isFileSelected = true;
      this.form.controls['AttachmentFileName'].setValue(this.fileName);
      document.body.removeChild(inputElement);
    });
  }
  upload(data?) {
    if (this.form.value.downloadtype) {
      let formData: FormData = new FormData();
        formData.append('file', this.file);

      if (this.form.value.downloadtype == "2") {
       

        this.DebitOrderNotificationService.BulkSendRemainderMailToCustomer(formData).subscribe((result) => {
          console.log(result);
          Swal.fire('information!,', 'Bulk Send of Suspension Remainder Mail will be updated shortly and will notify you once the process completed', "info");
        });
      }
      else if (this.form.value.downloadtype == "3") {
        formData.append('ManageSuspensionIdKey', "0");
        formData.append('BatchProcessModuleType', BatchProcessModuleType.suspendCustomers.toString());
        this.DebitOrderNotificationService.BulkSuspendCustomers(formData).subscribe((result) => {
          console.log(result);
          Swal.fire('information!,', 'Bulk Customer Suspension will be updated shortly and will notify you once the process completed', "info");
        });
      }
      else if (this.form.value.downloadtype == "1") {
        formData.append('BatchProcessModuleType', BatchProcessModuleType.paymentArrangement.toString());
        formData.append('paymentArrangementIdKey', "0");
        this.DebitOrderNotificationService.bulkpaymentarrangement(formData).subscribe((result) => {
          console.log(result);
          Swal.fire('information!,', 'Bulk payment Arrangement will be updated shortly and will notify you once the process completed', "info");
        });
      }
      else {
        formData.append('BatchProcessModuleType', BatchProcessModuleType.BulkRevoke.toString());
        formData.append('ManageSuspensionIdKey', "0");
        this.DebitOrderNotificationService.ProcessBulkRevoke(formData).subscribe((result) => {
          console.log(result);
          Swal.fire('information!,', 'Bulk Customer Invoke will be updated shortly and will notify you once the process completed', "info");
        });
      }
    }
  }
  reset() {
    const txt = 'Are you sure you want to delete?';
    const Yes = 'Yes';
    const No = 'No';
    Swal.fire({
      text: txt,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#7D32DE',
      cancelButtonColor: '#23C00A',
      confirmButtonText: Yes,
      cancelButtonText: No,
    }).then((result) => {
      if (result.value) {
        this.fileName = '';
        this.isFileSelected = false;
        this.form.controls['AttachmentFileName'].setValue(this.fileName);
      }
    });
  }

  downloadExcel() {
    if (this.form.value.downloadtype) {
      debugger
      this.reportService.downloadRemainderMailTemplate().subscribe((result) => {
        if (result) {
          const linkSource = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64, ' + result;
          const downloadLink = document.createElement('a');
          let fileName = 'Bulk Invoke template.xlsx';

          if (this.form.value.downloadtype == "2")
            fileName = 'Remainder Mail template.xlsx';

          else if (this.form.value.downloadtype == "3")
            fileName = 'Bulk Suspension template.xlsx';

          else if (this.form.value.downloadtype == "1")
            fileName = 'Payment Arrangement template.xlsx';
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
        }
      })

    }
  }

  Processtye(e) {
    console.log(e);

    this.show = false
    setTimeout(() => {
      this.show = true
    }, 200);

  }

  get typeOfFile(): string {
    const downloadType = parseInt(this.form.value.downloadtype);
    return this.TypeOfProcess[downloadType];
  }

}
